import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../shared/makeApiCall";
import { axiosApiInstance } from "../../axios";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";

import { SnackbarData, SnackbarType } from "../../components/Snackbar";
import { generateUniqueNumber } from "../../shared/utility";

import AddMakeToOrderModel from "../../components/forms/workOrders/AddMakeToOrderModel";
import AddServiceToOrderModal from "../../components/forms/workOrders/AddServiceToOrderModal";

export function WorkOrderDetailsViewModel(logout, id, addSnackbar) {
  const [customers, setCustomers] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [services, setServices] = useState();
  const [workOrder, setWorkOrder] = useState({
    id: -1,
    customer: { label: "" },
    makes: [],
    customer_info: { email: "" },
  });
  const [emailWoInProgress, setEmailWoInProgress] = useState(false);
  const [updateImageTitleInProgress, setUpdateImageTitleInProgress] =
    useState(false);

  const getCustomersForDropdown = async function () {
    let callResult = await makeGetApiCall(`customersForDropdown`);
    if (callResult.success) {
      setCustomers(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const getEmployeesForDropdown = async function () {
    let callResult = await makeGetApiCall(`usersForDropdown`);
    if (callResult.success) {
      setEmployeeOptions(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const getServicesForDropdown = async function () {
    let callResult = await makeGetApiCall(`servicesForDropdown`);
    if (callResult.success) {
      setServices(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const updateWorkOrderApiCall = async function (newOrder) {
    let callResult = await makePostApiCall(
      `workOrders/${id}`,
      {
        ...newOrder,
        check_heat_exchanger: newOrder.check_heat_exchanger ? 1 : 0,
        check_burners: newOrder.check_burners ? 1 : 0,
        check_pilot_assembly: newOrder.check_pilot_assembly ? 1 : 0,
        check_venting: newOrder.check_venting ? 1 : 0,
        check_high_limit_and_fan_control:
          newOrder.check_high_limit_and_fan_control ? 1 : 0,
        check_temperature_rise: newOrder.check_temperature_rise ? 1 : 0,
        check_carbon_monoxide_in_flue_products:
          newOrder.check_carbon_monoxide_in_flue_products ? 1 : 0,
        check_combustion_and_ventilation_air_supply:
          newOrder.check_combustion_and_ventilation_air_supply ? 1 : 0,
        check_compressor_and_fan_contactors:
          newOrder.check_compressor_and_fan_contactors ? 1 : 0,
        check_refrigerant_charge: newOrder.check_refrigerant_charge ? 1 : 0,
        check_safety_controls_set_points_and_functions:
          newOrder.check_safety_controls_set_points_and_functions ? 1 : 0,
        check_condition_of_evaporator_and_condenser_coils:
          newOrder.check_condition_of_evaporator_and_condenser_coils ? 1 : 0,
        check_condensate_drain_trap_and_pan:
          newOrder.check_condensate_drain_trap_and_pan ? 1 : 0,
        check_circulating_air_blower: newOrder.check_circulating_air_blower
          ? 1
          : 0,
        check_belts_and_pulleys: newOrder.check_belts_and_pulleys ? 1 : 0,
        check_motor_amperages: newOrder.check_motor_amperages ? 1 : 0,
        check_thermostats: newOrder.check_thermostats ? 1 : 0,
        check_filter: newOrder.check_filter ? 1 : 0,
        check_all_access_panels_to_be_secure:
          newOrder.check_all_access_panels_to_be_secure ? 1 : 0,
        check_all_electrical_connections:
          newOrder.check_all_electrical_connections ? 1 : 0,
        check_disconnects: newOrder.check_disconnects ? 1 : 0,
        check_gas_piping: newOrder.check_gas_piping ? 1 : 0,
        check_exhaust_fan: newOrder.check_exhaust_fan ? 1 : 0,
      },
      "multipart/form-data"
    );
    if (callResult.success) {
      setWorkOrder(newOrder);
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const getWorkOrder = async function () {
    let callResult = await makeGetApiCall(`workOrders/${id}`);
    if (callResult.success) {
      setWorkOrder(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const addServiceToOrderCall = async function (newItem) {
    let callResult = await makePostApiCall(`workOrderItems/add`, {
      ...newItem,
      work_order_id: id,
    });
    if (callResult.success) {
      // setWorkOrder(callResult.data);
      getWorkOrder(id);
    } else {
      showErrorModal(callResult.data.message);
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const onItemEditComplete = async function (itemToUpdate) {
    let callResult = await makePostApiCall(
      `workOrderItems/update/${itemToUpdate.id}`,
      itemToUpdate
    );

    if (callResult.success) {
      // setWorkOrder(callResult.data);
      getWorkOrder(id);
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Order item updated",
          SnackbarType.Success
        )
      );
    } else {
      showErrorModal(callResult.data.message);
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const onDeleteItem = async function (itemToDelete) {
    let callResult = await makePostApiCall(
      `workOrderItems/delete/${itemToDelete.id}`
    );
    if (callResult.success) {
      // setWorkOrder(callResult.data);
      getWorkOrder(id);
      setEmptyModelOpen({ childComponent: null, open: false });
    } else {
      showErrorModal(callResult.data.message);
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteOrderItem = function (itemToDelete) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => onDeleteItem(itemToDelete)}
          message={`Are you sure you want to delete ${itemToDelete.service_name}?`}
          hideReason={true}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  const printWorkOrder = async function () {
    let callResult = await makeGetApiCall(`printWorkOrder/${id}`);

    if (callResult.success) {
      window.open(callResult.data.location, "_blank");
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  const getMakesForWorkOrder = async function () {
    let callResult = await makeGetApiCall(`workOrderMakes/${workOrder.id}`);
    if (callResult.success) {
      setWorkOrder({ ...workOrder, makes: callResult.data });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const addNewMake = async function (make) {
    let callResult = await makePostApiCall(`workOrderMakes`, {
      ...make,
      work_order_id: workOrder.id,
    });
    if (callResult.success) {
      getMakesForWorkOrder();
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const updateMake = async function (make) {
    let callResult = await makePutApiCall(`workOrderMakes/${make.id}`, make);
    if (callResult.success) {
      getMakesForWorkOrder();
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const openAddNewMakeModal = (isEdit, make) => {
    setEmptyModelOpen({
      childComponent: (
        <AddMakeToOrderModel
          make={make}
          isEdit={isEdit}
          confirmAction={isEdit ? updateMake : addNewMake}
          setOpen={setEmptyModelOpen}
        />
      ),

      open: true,
    });
  };

  const removeImageAtIndexCall = async function (mediaId) {
    let callResult = await makePostApiCall(`deleteMedia/${mediaId}`);
    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const uploadNewImageCall = async function (data) {
    const formData = new FormData();
    formData.append("work_order_id", data.work_order_id);

    // Append each file to the FormData
    data.files.forEach((file, index) => {
      formData.append(`files[${index}]`, file);
    });

    // Add user info to FormData since makePostApiCall won't handle it properly
    const user_id = localStorage.getItem("id") * 1;
    const user_name = localStorage.getItem("name");
    formData.append("user_id", user_id);
    formData.append("user_name", user_name);

    // Use axios directly for FormData to avoid the spreading issue
    const config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("authToken"),
        "content-type": "multipart/form-data",
      },
    };

    let callResult;
    try {
      const response = await axiosApiInstance.post(
        `media/create`,
        formData,
        config
      );
      callResult = {
        success: true,
        data: response.data,
      };
    } catch (err) {
      if (err.response) {
        callResult = {
          success: false,
          data: err.response.data,
          errorStatus: err.response.status,
        };
      } else {
        callResult = {
          success: false,
          data: {
            title: "Error",
            subtitle: "We could not complete the action.",
            errorStatus: err.response?.status || 500,
          },
        };
      }
    }
    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    return callResult;
  };

  function askEditOrderItem(selectedOrderItem) {
    setEmptyModelOpen({
      childComponent: (
        <AddServiceToOrderModal
          service={selectedOrderItem}
          isEdit={true}
          confirmAction={onItemEditComplete}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  }

  const emailInvoice = async function () {
    setEmailWoInProgress(true);
    let callResult = await makePostApiCall(`emailInvoice/${id}`);
    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
    setEmailWoInProgress(false);
  };

  const updateImageTitle = async function (imageId, title) {
    setUpdateImageTitleInProgress(true);
    let callResult = await makePostApiCall(
      `media/updateImageTitle/${imageId}`,
      {
        title: title,
      }
    );
    if (callResult.success) {
      // Update local state to reflect the change immediately
      setWorkOrder((prevWorkOrder) => ({
        ...prevWorkOrder,
        medias: prevWorkOrder.medias.map((media) =>
          media.id === imageId ? { ...media, title: title } : media
        ),
      }));

      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message || "Image title updated successfully",
          SnackbarType.Success
        )
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message || "Failed to update image title");
    }
    setUpdateImageTitleInProgress(false);
    return callResult;
  };

  return {
    customers,
    getCustomersForDropdown,
    employeeOptions,
    getEmployeesForDropdown,
    services,
    getServicesForDropdown,
    getWorkOrder,
    setEmptyModelOpen,
    emptyModal,
    showErrorModal,
    updateWorkOrderApiCall,
    workOrder,
    addServiceToOrderCall,
    onItemEditComplete,
    askEditOrderItem,
    askDeleteOrderItem,
    printWorkOrder,
    openAddNewMakeModal,
    removeImageAtIndexCall,
    uploadNewImageCall,
    emailInvoice,
    emailWoInProgress,
    updateImageTitle,
    updateImageTitleInProgress,
  };
}
